import React from 'react'
import styled from 'styled-components'
import {Layout} from 'TemplateEditor/Layout'
import EditorProvider from 'TemplateEditor/EditorProvider'
import TemplateProvider from 'TemplateEditor/TemplateProvider'
import {useOrganizationEvent} from 'organization/Event/OrganizationEventProvider'
import FunctionsProvider from 'TemplateEditor/FunctionsProvider'
require('./templateStyles.css')

const EditorRoot = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
`

export function TemplateEditor() {
  const {event, updateEventTemplate} = useOrganizationEvent()

  if (!event) return null

  return (
    <FunctionsProvider>
      <EditorRoot>
        <TemplateProvider
          event={event}
          updateEventTemplate={updateEventTemplate}
        >
          <EditorProvider editMode={true} nonInteractiveSalesInViewerMode>
            <Layout />
          </EditorProvider>
        </TemplateProvider>
      </EditorRoot>
    </FunctionsProvider>
  )
}
